<template lang="pug">
link-base.link-download(@click='clickEvent')
  image-base.link-download__icon(:src='require(`@/assets/img/${img}`)')
  .link-download__text.font-bold
    slot
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import LinkBase from '@/components/atoms/LinkBase.vue'
import ImageBase from '@/components/atoms/ImageBase.vue'

@Component({
  components: {
    LinkBase,
    ImageBase,
  },
})
/**
 * ダウンロード用のアイコン付きリンク
 */
export default class LinkDownload extends Vue {
  @Prop()
  img!: string

  private clickEvent(key: Event): void {
    this.$emit('click', key)
  }
}
</script>

<style lang="stylus" scoped>
.link-download
  text-decoration none
  &__icon
    width 60px
    height 60px
</style>
